import { __decorate } from "tslib";
import { Vue, Component } from 'vue-property-decorator';
import BaseMap from '@blade-sxp/map-new/index.vue';
import DrawMap from './draw-map.vue';
import { reconvertLocation } from '@blade-sxp/map/utils';
// import card from './tool-card.vue';
import device from './device.vue';
import ExtendsTest from './extends-test.vue';
// import device from '@blade-sxp/alarm-map/pages/dashboard/components/map/device.vue';
import { createDialog } from '@blade-sxp/screen/utils/dialogControl';
import { timeToAngle } from '@blade-sxp/screen/utils/index';
// import { drawLine } from '../components/utils/draw-line';
import screenStore from '@blade-sxp/screen/store/index';
import Alarm from '@blade-sxp/screen/pages/alert-map/components/map/alarm.vue';
let Test = class Test extends Vue {
    personNum = 3;
    toolTipsList = [];
    roiList = [];
    videoList = [];
    deviceList = [];
    imageList = [];
    // heatMapList = [];
    hotAreaList = [];
    personList = [];
    mapUrl = '';
    mapId = '';
    map = null;
    operationMode = 'sandTable';
    sunTime = '2022-9-22 10:00:00';
    angle = 35;
    options = [
        { value: 'sandTable', label: '沙盘模式' },
        { value: 'fly', label: '飞行模式' },
        { value: 'travel', label: '行人模式' },
        { value: 'cruise', label: '巡视模式' },
    ];
    deviceVisible = true;
    mode = 'mark';
    carParkingList = [];
    weather = 'sunny';
    get backgroundWidth() {
        return this.map?.getBackroundInfo().width || 0;
    }
    get backgroundHeight() {
        return this.map?.getBackroundInfo().height || 0;
    }
    get allDeviceList() {
        return this.deviceList.map((item) => {
            return {
                ...item,
                visible: this.deviceVisible,
                vueConfig: {
                    instance: device,
                    data: { ...item },
                    emitMethods: { deviceClick: this.deviceClick },
                },
            };
        });
    }
    lineList = [];
    pathList = [];
    mainAngle = { camera: { x: 100, y: 20, z: 200 }, target: { x: 100, y: 20, z: 0 } };
    typeArr = ['critical', 'major', 'minor', 'normal', 'complex'];
    path;
    //     heatMapLists = (Array(5000).fill(0)).map(() => (
    //       {
    //         theme: this.typeArr[Math.floor(this.typeArr.length * Math.random())],
    //         vertices: {
    //           x: Math.random() * 300,
    //           y: Math.random() * 300,
    //           z: Math.random() * 300,
    //         }
    //       }));
    //       heatMapLists2 = (Array(5000).fill(0)).map(() => (
    //         {
    //           theme: this.typeArr[Math.floor(this.typeArr.length * Math.random())],
    //           vertices: {
    //             x: Math.random() * -300,
    //             y: Math.random() * -300,
    //             z: Math.random() * -300,
    //           }
    //         }));
    // heatMapList =[...this.heatMapLists, ...this.heatMapLists2]
    heatMapList = [
        {
            theme: 'complex',
            vertices: [
                {},
                {
                    x: Math.random() * 500,
                    y: Math.random() * 500,
                    z: Math.random() * 500,
                },
            ],
            colorStops: [
                {
                    // offset: 0,
                    color: 'red',
                },
            ],
        },
    ];
    // imageList = (Array(100).fill(0)).map(() => ({
    //   width: 20,
    //   onMouseEnter: () => {
    //     console.log('进来了');
    //   },
    //   url: 'data:image/jpeg;base64,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',
    //   vertices: {
    //     x: Math.random(),
    //     y: Math.random()
    //   },
    // }));
    loading = false;
    getRoi = false;
    progress = 0;
    async onStart() {
        this.loading = true;
        // 请求octree时自动加进地图内；异步方法
        // await this.map?.fetchOctree(this.mapUrl);
        // console.log('八叉树结束');
    }
    open() {
        screenStore.updateSingleMapData({
            key: 'operationMode',
            value: 'cruise',
        });
    }
    handleVideo() {
        this.videoList[0].id = '2';
        this.videoList[0].videoURL = '/video1.mp4';
    }
    getPoints() {
        this.getRoi = true;
    }
    setSunPosition() {
        this.map?.setSunPosition(this.angle);
    }
    setTime() {
        const angle = timeToAngle(this.sunTime);
        if (!isNaN(angle)) {
            this.angle = angle;
        }
    }
    addRain() {
        // this.map?.setWeather('rainy');
        this.weather = 'rainy';
    }
    addCloud() {
        // this.map?.setWeather('cloudy');
        this.weather = 'cloudy';
    }
    addSun() {
        // this.map?.setWeather('sunny');
        this.weather = 'sunny';
    }
    addSnow() {
        // this.map?.setWeather('snowy');
        this.weather = 'snowy';
    }
    moveToMapPoint() {
        this.$refs['map']?.moveToMapPoint({
            x: -876.47797,
            y: 3.6000001,
            z: -52.21477,
        });
    }
    onProgress(progress) {
        this.progress = Number((parseInt(String((progress.loaded / progress.total) * 1000)) / 10).toFixed(2));
    }
    deviceClick(deviceInfo) {
        createDialog(Alarm, deviceInfo);
    }
    onEnd() {
        this.loading = false;
        this.progress = 0;
    }
    onError() { }
    setMode() {
        const modeList = ['normal', 'roiChose', 'verticalView', 'mark'];
        this.mode = modeList[Math.floor(modeList.length * Math.random())];
        console.log(this.mode);
    }
    draw(geoType, pointsOffset) {
        if (geoType === 'polygon') {
            pointsOffset = pointsOffset.map((point) => {
                const { x, y } = this.map.clientToMapPosition(point.x, point.y);
                return reconvertLocation(x, y, { height: this.backgroundHeight, width: this.backgroundWidth });
            });
        }
        console.log(pointsOffset);
    }
    // addLabel(card:any, domData?:any) {
    //   const outDom = document.createElement('div');
    //   const dom = document.createElement('div');
    //   outDom.appendChild(dom);
    //   const Tool = Vue.extend(card);
    //   const tool = new Tool(Object.assign({}, domData));
    //   tool.$mount(dom);
    //   return outDom;
    // }
    mapClick(target, targets, position) {
        // console.log('this.mode', this.operationMode);
        // if (this.operationMode === 'travel') {
        //   console.log(this.$refs['map'] as any);
        //   (this.$refs['map'] as any).setPersonInitPosition(position.worldPosition);
        // }
        // this.path?.onClick(target, targets, position);
    }
    mapMouseMove(target, targets, position) {
        // this.path?.onMouseMove(position.worldPosition);
    }
    drawEnd(data) {
        let item = {
            theme: 'roi',
            type: 'roi3d',
            title: 'parking',
            id: '444',
            opacity: 0,
            onMouseEnter: () => {
                console.log('11111');
            },
            vertices: data.positionList,
        };
        console.log(item);
        this.roiList.push(item);
        this.path = undefined;
        console.log(data);
    }
    moveToMesh() {
        this.mode = 'roiChose';
        this.$nextTick(() => {
            this.$refs['map']?.moveToMesh('UCX_05_004_01');
        });
    }
    addDevice() {
        const list = ['ONLINE', 'OFFLINE', 'UNUSUAL'];
        this.deviceList = [
            ...this.deviceList,
            {
                id: new Date().getTime(),
                status: list[Math.floor(list.length * Math.random())],
                vertices: {
                    x: Math.random(),
                    y: Math.random(),
                    z: 0,
                },
            },
        ];
    }
    changeDeviceStatus() {
        this.deviceVisible = !this.deviceVisible;
    }
    updateZoneId() {
        this.mapId = String(new Date().getTime());
        this.mapUrl = '/gltf/JYC/ST_0620.gltf';
        // this.mapUrl = '/JYC_Model_Export_0620/01/01.gltf';
        // this.mapUrl = '/gltf/wadi/01.gltf';
        // this.mapUrl = '/3d/33ae6df0-b8c0-4242-9e72-4befcb715f03_1667288794612/ST_0620.gltf';
        // this.mapUrl = 'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fimg.jj20.com%2Fup%2Fallimg%2F1114%2F011621113142%2F210116113142-10-1200.jpg&refer=http%3A%2F%2Fimg.jj20.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1657079200&t=8aa3e42c0e7716c7e4ef605c4d229236';
    }
    delDevice(id) {
        let index = this.deviceList.findIndex((device) => device.id === id);
        if (index !== -1) {
            this.deviceList.splice(index, 1);
        }
    }
    getPosition(event) {
        // const point = (this.$refs['map'] as any)?.getPosition(event);
        // console.log(point);
        console.log(this.$refs['map']?.getWorldPosition({
            x: 0,
            y: 0,
        }));
        this.getRoi = false;
    }
    zoomReset() {
        this.$refs['map']?.zoomReset();
    }
    removeMap() {
        this.$refs['map']?.removeMap();
    }
    getMainAngle() {
        console.log(this.$refs['map']?.getMainAngle());
    }
    zoomOut() {
        this.$refs['map']?.zoomOut();
    }
    zoomIn() {
        this.$refs['map']?.zoomIn();
    }
    loadMap() {
        this.map = this.$refs['map'];
        console.log('地图初始化完成');
    }
    moveToPoint(params) {
        this.$refs['map']?.moveToPoint(params);
    }
    updateMap(val) {
        if (val === 0) {
            console.log('元素更新完成');
        }
        else if (val === 1) {
            console.log('地图更新完成');
        }
    }
    mounted() {
        // this.path = drawLine({ mapType: '3D-Three.js', drawEnd: this.drawEnd, isNeedClosed: true, isNeedDirection: true });
        this.pathList = [
            {
                id: 'path1',
                covering: true,
                coveringCount: 2,
                speed: 1,
                width: 2,
                type: 'Arrow2',
                cycle: false,
                show: true,
                patrol: false,
                isClick: 'mapSetting',
                vertices: [
                    { x: 164.53369, y: 3.399994, z: -231.891 },
                    { x: -169.66269, y: 3.399994, z: -239.60005 },
                    { x: -358.73657, y: 3.399994, z: -236.0013 },
                    { x: -492.0655, y: 2.7464073, z: -117.148346 },
                    { x: -492.0655, y: 2.7464073, z: -117.148346 },
                ],
            },
            {
                id: 'path2',
                covering: true,
                coveringCount: 2,
                speed: 1,
                width: 2,
                type: 'Arrow1',
                cycle: false,
                show: true,
                patrol: false,
                isClick: 'mapSetting',
                vertices: [
                    { x: 306.78033, y: 1.646082, z: -81.07217 },
                    { x: 22.831148, y: 1.4000006, z: -116.92509 },
                    { x: 52.923843, y: 3.399994, z: -206.3805 },
                    { x: -308.8, y: 3.399994, z: -204.47766 },
                    { x: -451.87616, y: 1.4000007, z: -86.65102 },
                ],
            },
        ];
        /**
         *
         * Arrow2
    :
    {x: 164.53369, y: 3.399994, z: -231.891}
    1
    :
    {x: -169.66269, y: 3.399994, z: -239.60005}
    2
    :
    {x: -358.73657, y: 3.399994, z: -236.0013}
    3
    :
    {x: -492.0655, y: 2.7464073, z: -117.148346}
    4
    :
    {x: -492.0655, y: 2.7464073, z: -117.148346}
    
    
    
    Arrow1
    :
    {x: 306.78033, y: 1.646082, z: -81.07217}
    1
    :
    {x: 22.831148, y: 1.4000006, z: -116.92509}
    2
    :
    {x: 52.923843, y: 3.399994, z: -206.3805}
    3
    :
    {x: -308.8, y: 3.399994, z: -204.47766}
    4
    :
    {x: -451.87616, y: 1.4000007, z: -86.65102}
        */
        this.lineList = [
            {
                lineColor: '#ffcc00',
                chooseIndex: 7,
                vertices: [
                    {
                        x: -871.35236,
                        y: 80.43,
                        z: 103.525035,
                    },
                    {
                        x: -901.35236,
                        y: 80.43,
                        z: 83.525035,
                    },
                    {
                        x: -921.35236,
                        y: 80.43,
                        z: 107.315224,
                    },
                    {
                        x: -933.44763,
                        y: 80.43,
                        z: 57.315224,
                    },
                    {
                        x: -973.44763,
                        y: 80.43,
                        z: 77.315224,
                    },
                    {
                        x: -953.44763,
                        y: 80.43,
                        z: 47.315224,
                    },
                    {
                        x: -903.44763,
                        y: 80.43,
                        z: 37.315224,
                    },
                    {
                        x: -883.44763,
                        y: 80.43,
                        z: 57.315224,
                    },
                ],
                // vertices: [
                //   {
                //     x: -921.35236,
                //     z: 50.400084,
                //     y: 83.525035,
                //   },
                //   {
                //     x: -943.44763,
                //     z: 50.43,
                //     y: 107.315224,
                //   },
                //   {
                //     x: -933.44763,
                //     z: 50.43,
                //     y: 57.315224,
                //   },
                //   {
                //     x: -973.44763,
                //     z: 50.43,
                //     y: 77.315224,
                //   },
                //   {
                //     x: -943.44763,
                //     z: 50.43,
                //     y: 80.315224,
                //   },
                // ],
            },
        ];
        // this.carParkingList = new Array(1).fill(0).map((item, index) => {
        //   return {
        //     theme: 'idleParking',
        //     id: 'parking' + index,
        //     showCar: true,
        //     direction: { x: 0.090046614, y: 2.206205e-15, z: 1.7337409 }, // 3d小车方向
        //     carUrl: '', // 2d小车图片
        //     carWidth: '', // 2d小车宽度
        //     carHeight: '', // 2d小车长度
        //     rotate: '', // 2d小车旋转角度
        //     vertices: [
        //       {
        //         x: 6.8588066,
        //         y: 3.5000017,
        //         z: -1.3920994,
        //       },
        //       {
        //         x: 6.5063977,
        //         y: 3.5000017,
        //         z: 1.4256265,
        //       },
        //       {
        //         x: 8.240139,
        //         y: 3.5000017,
        //         z: 1.3355799,
        //       },
        //       {
        //         x: 8.571398,
        //         y: 3.5000017,
        //         z: -1.0052949,
        //       },
        //       {
        //         x: 6.8588066,
        //         y: 3.5000017,
        //         z: -1.3920994,
        //       },
        //     ],
        //   };
        // });
        this.carParkingList = [
            {
                theme: 'unknownParking',
                id: 'parking1',
                showCar: true,
                direction: { x: -1, y: 0, z: 0 },
                carUrl: '',
                carWidth: '',
                carHeight: '',
                rotate: '',
                isPark: true,
                vertices: [
                    {
                        x: 100,
                        y: 20,
                        z: 90,
                    },
                    {
                        x: 100,
                        y: 20,
                        z: 95,
                    },
                    {
                        x: 90,
                        y: 20,
                        z: 95,
                    },
                    {
                        x: 90,
                        y: 20,
                        z: 90,
                    },
                ],
            },
        ];
        // this.roiList = [
        //   {
        //     theme: 'employParking',
        //     id: 'parking1',
        //     type: 'parking3d',
        //     vertices: [
        //       {
        //         x: 100,
        //         y: 20,
        //         z: 90,
        //       },
        //       {
        //         x: 100,
        //         y: 20,
        //         z: 95,
        //       },
        //       {
        //         x: 90,
        //         y: 20,
        //         z: 95,
        //       },
        //       {
        //         x: 90,
        //         y: 20,
        //         z: 90,
        //       },
        //     ],
        //   },
        // ];
        this.roiList = [
            {
                theme: 'twill',
                type: 'roi3d',
                title: '',
                id: '1',
                opacity: 1,
                onMouseEnter: () => {
                    console.log('222');
                },
                vertices: [
                    {
                        x: 18.130228,
                        y: 3.050001,
                        z: 65.01626 - 30,
                    },
                    {
                        x: 19.329166,
                        y: 3.2000017,
                        z: 45.62102 - 30,
                    },
                    {
                        x: 47.735413,
                        y: 2.8500016,
                        z: 46.61474 - 30,
                    },
                    {
                        x: 46.220356,
                        y: 3.2000017,
                        z: 64.689255 - 30,
                    },
                    {
                        x: 18.130228,
                        y: 3.050001,
                        z: 65.01626 - 30,
                    },
                ],
            },
            {
                theme: 'twill',
                type: 'roi3d',
                title: '',
                id: '2',
                onMouseEnter: () => {
                    console.log('11111');
                },
                vertices: [
                    {
                        x: 100,
                        y: 100,
                        z: 100,
                    },
                    {
                        x: 100,
                        y: 100,
                        z: 200,
                    },
                    {
                        x: 200,
                        y: 50,
                        z: 200,
                    },
                    {
                        x: 200,
                        y: 50,
                        z: 100,
                    },
                    {
                        x: 100,
                        y: 100,
                        z: 100,
                    },
                ],
            },
            {
                theme: 'fence',
                type: 'roi3d',
                title: '',
                id: '2',
                vertices: [
                    {
                        x: 100,
                        y: 20,
                        z: 0,
                    },
                    {
                        x: 100,
                        y: 20,
                        z: 95,
                    },
                    {
                        x: 0,
                        y: 20,
                        z: 95,
                    },
                    {
                        x: 0,
                        y: 20,
                        z: 0,
                    },
                ],
            },
            {
                theme: 'stripe',
                type: 'roi3d',
                title: '测试',
                id: '555',
                vertices: [
                    {
                        x: 300,
                        y: 50,
                        z: 100,
                    },
                    {
                        x: 300,
                        y: 50,
                        z: 200,
                    },
                    {
                        x: 400,
                        y: 100,
                        z: 200,
                    },
                    {
                        x: 400,
                        y: 100,
                        z: 100,
                    },
                ],
            },
            // {
            //   theme: 'roi',
            //   type: 'roi3d',
            //   title: '',
            //   id: '444',
            //   opacity: 0,
            //   vertices: [
            //     {
            //       x: -843.7054564636836,
            //       y: 3.4000016808160907,
            //       z: 12.183295266929491,
            //     },
            //     {
            //       x: -843.4801336090807,
            //       y: 3.4000016808160907,
            //       z: -5.046912324257334,
            //     },
            //     {
            //       x: -876.162674634639,
            //       y: 3.4000016808160907,
            //       z: -20.349761974630972,
            //     },
            //     {
            //       x: -875.7329304731151,
            //       y: 3.4000016808160907,
            //       z: 81.23162895402649,
            //     },
            //   ],
            // },
            // {
            //   theme: 'roi',
            //   type: 'roi3d',
            //   title: '',
            //   id: '2484',
            //   opacity: 0,
            //   vertices: [
            //     {
            //       x: -870.52234,
            //       y: 2.1991062,
            //       z: 26.752356,
            //     },
            //     {
            //       x: -888.3096,
            //       y: 2.1999447,
            //       z: 25.386837,
            //     },
            //     {
            //       x: -888.23865,
            //       y: 2.0512283,
            //       z: 37.593494,
            //     },
            //     {
            //       x: -867.22046,
            //       y: 2.199116,
            //       z: 37.690125,
            //     },
            //     {
            //       x: -855.2349,
            //       y: 2.1983871,
            //       z: 28.013975,
            //     },
            //     {
            //       x: -859.85156,
            //       y: 2.1985223,
            //       z: 22.343494,
            //     },
            //   ],
            // },
            // {
            //   theme: 'roi',
            //   type: 'roi3d',
            //   title: '',
            //   id: '2493',
            //   opacity: 0,
            //   vertices: [
            //     {
            //       x: -890.8039,
            //       y: 2.1513302,
            //       z: 0.365701,
            //     },
            //     {
            //       x: -890.3152,
            //       y: 2.1931999,
            //       z: 19.916191,
            //     },
            //     {
            //       x: -850.44165,
            //       y: 1.8984969,
            //       z: 9.906315,
            //     },
            //     {
            //       x: -852.6527,
            //       y: 2.1842234,
            //       z: -3.0776038,
            //     },
            //   ],
            // },
            // {
            //   theme: 'roi',
            //   type: 'roi3d',
            //   title: '测试1',
            //   id: '222',
            //   vertices: [
            //     {
            //       x: 100,
            //       y: 100,
            //       z: -100,
            //     },
            //     {
            //       x: 100,
            //       y: 100,
            //       z: -200,
            //     },
            //     {
            //       x: 200,
            //       y: 100,
            //       z: -200,
            //     },
            //     {
            //       x: 200,
            //       y: 100,
            //       z: -100,
            //     },
            //   ],
            // },
            // {
            //   theme: 'roi',
            //   type: 'roi3d',
            //   id: '111',
            //   title: '测试1',
            //   vertices: [
            //     {
            //       x: 100,
            //       y: 100,
            //       z: 0,
            //     },
            //     {
            //       x: 100,
            //       y: 200,
            //       z: 0,
            //     },
            //     {
            //       x: 200,
            //       y: 200,
            //       z: 0,
            //     },
            //     {
            //       x: 200,
            //       y: 100,
            //       z: 0,
            //     },
            //   ],
            // },
        ];
        // setInterval(() => {
        //   this.personList = new Array(Number(this.personNum)).fill(0).map((item, index) => {
        //     const vertices =
        //       index === 0
        //         ? {
        //             x: 100 + 100 / 2,
        //             y: 50 + 50 / 2,
        //             z: 100 + 100 / 2,
        //           }
        //         : {
        //             x: 100 + 100 * Math.random(),
        //             y: 50 + 50 * Math.random(),
        //             z: 100 + 100 * Math.random(),
        //           };
        //     // const vertices = {
        //     //   x: 0,
        //     //   y: 0,
        //     //   z: 0,
        //     // };
        //     // let gender = index%3 === 1? 'male';
        //     let gender = 'unknown';
        //     const num = index % 2;
        //     switch (num) {
        //       case 0:
        //         gender = 'male';
        //         break;
        //       case 1:
        //         gender = 'female';
        //         break;
        //       case 2:
        //         gender = 'unknown';
        //         break;
        //       default:
        //         gender = 'unknown';
        //     }
        //     return {
        //       id: `${index + 11}`,
        //       platformId: '2',
        //       // gender: 'female',
        //       gender: gender,
        //       // vertices: {
        //       //   x: -843 - 30 * Math.random(),
        //       //   y: 3.4 + 5 * Math.random(),
        //       //   z: -50 + 100 * Math.random(),
        //       // },
        //       vertices: vertices,
        //       signalColor: index % 2 === 1 ? 'red' : 'blue',
        //     };
        //   });
        // }, 1000);
        // roi设置
        // this.roiList = [
        //   {
        //     id: '75',
        //     theme: 'roi',
        //     title: '父区域3',
        //     opacity: 1,
        //     vertices: [
        //       {
        //         x: 0.40132782,
        //         y: 0.07216009,
        //       },
        //       {
        //         x: 0.2475558,
        //         y: 0.26663277,
        //       },
        //       {
        //         x: 0.49289992,
        //         y: 0.33664295,
        //       },
        //       {
        //         x: 0.6289992,
        //         y: 0.2664295,
        //       },
        //       {
        //         x: 0.40132782,
        //         y: 0.07216009,
        //       },
        //     ],
        //   },
        // ];
        // this.roiList = [
        //   {
        //     id: 'UCX_05_004_01_02',
        //     opacity: 0,
        //   },
        //   {
        //     id: 'UCX_05_004_01_01',
        //     opacity: 0,
        //   },
        //   {
        //     id: 'UCX_05_004_01',
        //     opacity: 0,
        //   },
        // ];
        this.videoList = [
            {
                id: '1',
                name: 'VIDEO-004-16vs9',
                videoURL: '/video.mp4',
                mode: '',
            },
        ];
        this.mapId = String(new Date().getTime());
        // this.mapUrl = '/gltf/wadi/01/01.gltf';
        // this.mapUrl = '/JYC/ST_0620.gltf';
        // this.mapUrl = '/gltf/BLVDCityOut230217/BLVDCityOut230217.gltf';
        this.mapUrl = '/gltf/JYC1New/JYC11/ST_0620.gltf'; // '/gltf/JYC/ST_0620.gltf';
        // this.mapUrl = '/BLVD_V7.1/BLVDCityOut1207.gltf';
        // this.mapUrl = '/JYC_Model_Export_0620/01/01.gltf';
        // this.mapUrl =
        //   '/biz-map-bucket/84_20220601210612.jpeg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=minio%2F20220602%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20220602T233900Z&X-Amz-Expires=604800&X-Amz-SignedHeaders=host&X-Amz-Signature=49fd6198b53843eb51bc16330672e123e24175757fd58d691f01d03f51ee4fd9'; // 地图url加载不出来的情况
        this.deviceList = [
            {
                id: '64',
                name: '车辆属性识别_1',
                status: 'ONLINE',
                vertices: {
                    x: -613.687759494506,
                    y: 169.96481232328932,
                    z: 109.29643762509349,
                },
                videoPreviewAddress: 'rtsp://root:Goodsense@2021@10.8.10.85:554/car_1.mp4',
            },
            {
                id: '289',
                name: 'CL2',
                status: 'ONLINE',
                vertices: {
                    x: -674.3580695753795,
                    y: 81.1716168956311,
                    z: -17.99441399676114,
                },
                videoPreviewAddress: 'rtsp://root:Goodsense@2021@10.8.10.85:554/crosslineCL2.mp4',
            },
            {
                id: '259',
                name: 'VA2',
                status: 'OFFLINE',
                vertices: {
                    x: -871.35236,
                    y: 3.400084,
                    z: -13.525035,
                },
                videoPreviewAddress: 'rtsp://root:Goodsense@2021@10.8.10.85:554/crosslineVA2.mp4',
            },
            {
                id: '100',
                name: '厨房_狗1',
                status: 'ONLINE',
                vertices: {
                    x: -843.44763,
                    y: 3.43,
                    z: -27.315224,
                },
                videoPreviewAddress: 'rtsp://root:Goodsense@2021@10.8.10.85:554/dog1',
            },
            {
                id: '133',
                name: '异常行为检测_打架1',
                status: 'OFFLINE',
                vertices: {
                    x: -726.0725,
                    y: 3.4261248,
                    z: -91.65829,
                },
                videoPreviewAddress: 'rtsp://root:Goodsense@2021@10.8.10.85:554/fight.mp4',
            },
            {
                id: '88',
                name: '道路_2',
                status: 'ONLINE',
                vertices: {
                    x: -841.43097,
                    y: 12.4452095,
                    z: 32.398518,
                },
                videoPreviewAddress: 'rtsp://root:Goodsense@2021@10.8.10.85:554/road_2.mp4',
            },
            {
                id: '265',
                name: 'VA4',
                status: 'OFFLINE',
                vertices: {
                    x: -768.84247,
                    y: 12.001294,
                    z: 156.32037,
                },
                videoPreviewAddress: 'rtsp://root:Goodsense@2021@10.8.10.85:554/crosslineVA4.mp4',
            },
            {
                id: '58',
                name: '人脸_3',
                status: 'OFFLINE',
                vertices: null,
                videoPreviewAddress: 'rtsp://root:Goodsense@2021@10.8.10.85:554/face3.mp4',
            },
            {
                id: '106',
                name: '厨房_行为1',
                status: 'OFFLINE',
                vertices: {
                    x: -836.67834,
                    y: 3.4300807,
                    z: -71.34059,
                },
                videoPreviewAddress: 'rtsp://root:Goodsense@2021@10.8.10.85:554/kitchen1',
            },
            {
                id: '124',
                name: '厨房_盒盖检测1',
                status: 'OFFLINE',
                vertices: {
                    x: -735.83984,
                    y: 12.659362,
                    z: -46.3862,
                },
                videoPreviewAddress: 'rtsp://root:Goodsense@2021@10.8.10.85:554/box_cover1',
            },
            {
                id: '316',
                name: '入侵2',
                status: 'ONLINE',
                vertices: {
                    x: -565.9219,
                    y: 3.3999953,
                    z: -332.05682,
                },
                videoPreviewAddress: 'rtsp://root:Goodsense@2021@10.8.10.85:554/crowdIntrusion3.mp4',
            },
            {
                id: '79',
                name: '垃圾_2',
                status: 'ONLINE',
                vertices: {
                    x: -795.1404,
                    y: 3.4,
                    z: -100.57938,
                },
                videoPreviewAddress: 'rtsp://root:Goodsense@2021@10.8.10.85:554/waste_2.mp4',
            },
        ];
        this.personList = [
            {
                id: 'personId_1',
                platformId: 1,
                personLv: 'normal',
                signalColor: 'red',
                gender: 'MALE',
                url: '',
                width: 40,
                height: 40,
                vertices: {
                    x: 10,
                    y: 10,
                    z: 10,
                },
            },
            {
                id: 'personId_2',
                platformId: 2,
                personLv: 'normal',
                signalColor: 'blue',
                gender: 'FEMALE',
                url: '',
                width: 40,
                height: 40,
                vertices: {
                    x: 150,
                    y: 10,
                    z: 150,
                },
            },
            {
                id: 'personId_3',
                platformId: 1,
                personLv: 'normal',
                signalColor: 'green',
                gender: 'UNKNOWN',
                url: '',
                width: 40,
                height: 40,
                vertices: {
                    x: 250,
                    y: 10,
                    z: 100,
                },
            },
        ];
    }
};
Test = __decorate([
    Component({
        name: 'test',
        components: { BaseMap, DrawMap, ExtendsTest },
    })
], Test);
export default Test;
